import { render, staticRenderFns } from "./C_SettingOnePage.vue?vue&type=template&id=2dcc69e9&scoped=true&"
import script from "./C_SettingOnePage.vue?vue&type=script&lang=js&"
export * from "./C_SettingOnePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc69e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcc69e9')) {
      api.createRecord('2dcc69e9', component.options)
    } else {
      api.reload('2dcc69e9', component.options)
    }
    module.hot.accept("./C_SettingOnePage.vue?vue&type=template&id=2dcc69e9&scoped=true&", function () {
      api.rerender('2dcc69e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/setting/C_SettingOnePage.vue"
export default component.exports